export default function decodeLL(num) {
    var degrees = (num & 0xff000000) >>> 24;
    var fraction = (num & 0x00fffffc) >>> 2;

    var dirbits = num & 0x3;

    fraction /= 4194303.0; // # 0x3FFFFF

    var dd = degrees + fraction;

    if(dirbits === 0x01 || dirbits === 0x03)
    {
        // south or west
        dd = - dd;
    }
    return dd;
}

 
export function encodeLL(value, direction) {
    if(value > 180.0 || value < 0.0)
    {
        throw new RangeError("Lat/Long value out of range");
    }

    var degrees = Math.floor(value);
    var fraction = (value - degrees) * 4194303.0;

    // console.log("Degrees: " + degrees + " fraction " + fraction);

    var encoded = degrees << 24;
    encoded |= fraction << 2;

    if(direction == 'N' || direction == 'n')
    {
        encoded |= 0x0;
    }
    else if(direction == 'S' || direction == 's')
    {
        encoded |= 0x1;
    }
    else if(direction == 'E' || direction == 'e')
    {
        encoded |= 0x2;
    }
    else if(direction == 'W' || direction == 'w')
    {
        encoded |= 0x3;
    }
    else
    {
        throw new RangeError("Invalid Direction");
    }

    return encoded;
}
